"use strict";
/* UTILS */
Object.defineProperty(exports, "__esModule", { value: true });
var Utils = {
    plusesRe: /\+{2,}/gi,
    whitespaceRe: /\s+/gi,
    isMac: /mac|ipod|iphone|ipad/i.test(navigator.platform),
    isEqual: function (x, y) {
        if (x.length !== y.length)
            return false;
        for (var i = 0, l = x.length; i < l; i++) {
            if (x[i] !== y[i])
                return false;
        }
        return true;
    },
    memoize: function (fn, resolver) {
        var cache = {};
        return function memoizedFunction() {
            var key = resolver ? resolver.apply(undefined, arguments) : arguments[0];
            if (key in cache)
                return cache[key];
            return cache[key] = fn.apply(undefined, arguments);
        };
    },
    memoizedShortcutIDResolver: function (id) { return id.toString(); }
};
/* EXPORT */
exports.default = Utils;
